module.exports = __webpack_public_path__ + "img/20190827144850725.627708ec.jpg";